module.exports = __webpack_public_path__ + "static/img/13_phase_function_Paper_PointsHejduk_Prediction.abd9526.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/13_phase_function_Paper_PointsHejduk_Prediction.png
// module id = e4VC
// module chunks = 0